import {
    projectsListRequestByUserId,
    getProjectByProjectId,
    updateSingleProjectByProjectId,
    updateProjectArchiveByProjectId,
    toggleEmailReminders,
} from "@/apis"
import {
    PROJECT_SENDING_REQUEST,
    PROJECT_LIST_SUCCESS,
    PROJECT_PENDING_DONE,
    PROJECT_SINGLE_UPDATE,
    PROJECT_REQUEST_FAIL,
    PROJECT_SINGLE_SUCCESS,
    PROJECT_SINGLE_UPDATE_FROM_ALL,
    TOGGLE_EMAIL_REMINDERS_SUCCESS,
    TOGGLE_EMAIL_REMINDERS_FAIL,
    PROJECT_SEARCH_INPUT,
} from "../action-types/project"

// eslint-disable-next-line import/prefer-default-export
export const getUserProjectList = (userId) => async (dispatch) => {
    dispatch({ type: PROJECT_SENDING_REQUEST })
    try {
        const result = await projectsListRequestByUserId(userId)
        const { projectList, message } = result.data
        const projectListGroupByProjectId = mergeProjectList(projectList)
        dispatch({
            type: PROJECT_LIST_SUCCESS,
            payload: { projectListGroupByProjectId, message },
        })
    } catch (error) {
        dispatch({ type: PROJECT_REQUEST_FAIL, payload: error.data.message })
    }
}

// group project by projectId
const mergeProjectList = (projectList) => {
    return projectList.reduce((previous, next) => {
        const index = previous.findIndex((item) => item.projectId === next.projectId)
        if (index >= 0) {
            previous[index].userRole.push({
                userRoleId: next.userRoleId,
            })
        } else {
            const newObj = {
                ...next,
                userRole: [
                    {
                        userRoleId: next.userRoleId,
                    },
                ],
            }
            delete newObj.userRoleId
            previous.push(newObj)
        }
        return previous
    }, [])
}

export const getProjectByProjectIdRequest = (projectId) => async (dispatch) => {
    dispatch({ type: PROJECT_SENDING_REQUEST })
    try {
        const result = await getProjectByProjectId(projectId)
        const { project, message } = result.data
        dispatch({
            type: PROJECT_SINGLE_SUCCESS,
            payload: { project, message },
        })
    } catch (error) {
        dispatch({ type: PROJECT_REQUEST_FAIL, payload: `Get Project Fails, ${error.data.message}` })
    } finally {
        dispatch({ type: PROJECT_PENDING_DONE })
    }
}

export const updateSingleProjectByProjectIdRequest =
    ({ projectId, newProject, redirect = false }) =>
    async (dispatch) => {
        try {
            const result = await updateSingleProjectByProjectId({ projectId, newProject })
            const { project, message } = result.data
            dispatch({
                type: PROJECT_SINGLE_UPDATE,
                payload: { project, message },
            })
        } catch (error) {
            dispatch({ type: PROJECT_REQUEST_FAIL, payload: error.data.message || error.data })
        } finally {
            dispatch({ type: PROJECT_PENDING_DONE, payload: { redirect } })
        }
    }

export const updateProjectArchiveByProjectIdRequest =
    ({ projectId, archiveStatus, redirect = false }) =>
    async (dispatch) => {
        try {
            const result = await updateProjectArchiveByProjectId({ projectId, archiveStatus })
            const { project, message } = result.data
            const { archive } = project
            dispatch({
                type: PROJECT_SINGLE_UPDATE_FROM_ALL,
                payload: {
                    projectId,
                    message,
                    projectUpdate: {
                        projectArchive: archive,
                    },
                },
            })
        } catch (error) {
            dispatch({ type: PROJECT_REQUEST_FAIL, payload: error.data.message || error.data })
        } finally {
            dispatch({ type: PROJECT_PENDING_DONE, payload: { redirect } })
        }
    }

export const updateEmailReminders = (projectId, status) => async (dispatch) => {
    try {
        const result = await toggleEmailReminders(projectId, status)
        const { data } = result
        dispatch({
            type: TOGGLE_EMAIL_REMINDERS_SUCCESS,
            payload: {
                data: data.data,
                projectId,
            },
        })
        return data
    } catch (error) {
        dispatch({ type: TOGGLE_EMAIL_REMINDERS_FAIL, payload: error.data.message || error.data })
        return undefined
    }
}

export const searchProject = (searchQuery) => (dispatch) => {
    dispatch({
        type: PROJECT_SEARCH_INPUT,
        payload: searchQuery,
    })
}
